import { action, computed, makeObservable, observable } from "mobx"
import Map from 'ol/Map'
import { Extent } from "ol/extent"
import { MutableRefObject } from "react"
import { FileMapLayers } from "./FileMap"

export type LayeredMap = {
	map: Map
	layers: FileMapLayers
	mapRef: MutableRefObject<Map | undefined>
}

export type OcrImageData = {
	pageNumber: number
	rendered: boolean
	extent: Extent
	dataUrl: string
	layeredMap?: LayeredMap
}

export interface IDocumentRenderer {
	pageCount: number
	pageImages: OcrImageData[]
	getPage: (pageNumber: number) => OcrImageData | undefined
	renderPage: (pageNumber: number, extent: Extent, dataUrl: string) => void
}

export class DocumentRenderer implements IDocumentRenderer {

	get pageCount(): number {
		return this._pageImages.length
	}

	get pageImages(): OcrImageData[] {
		return this._pageImages
	}

	getPage(pageNumber: number): OcrImageData | undefined {
		if (this._pageImages === undefined)
			throw new Error('The file could not be found')

		const image = this._pageImages.find(v => v.pageNumber === pageNumber)

		return image
	}

	renderPage = action((pageNumber: number, extent: Extent, dataUrl: string) => {
		console.log('render page')
		if (this._pageImages === undefined)
			throw new Error('the file could not be found')
		const image = this._pageImages.find(v => v.pageNumber === pageNumber)

		if (image === undefined)
			throw new Error("tried to render a page that doesn't exist")

		image.rendered = true
		image.extent = extent
		image.dataUrl = dataUrl
		return image
	})

	private _pageImages: OcrImageData[]

	constructor(pageImages: OcrImageData[]) {
		makeObservable<DocumentRenderer, "_pageImages">(this, {
			pageCount: computed,
			_pageImages: observable,
			pageImages: computed
		});

		this._pageImages = pageImages
	}
}